module.exports = __webpack_public_path__ + "static/media/sosis.2f959abf.png";